import { createAirbrakeClient as createAirbrakeClientBase } from './index.js'; // .js file extension is needed to avoid build failures in client apps.
import { Notifier as NotifierBrowser } from '@airbrake/browser';
/**
 * Creates a Notifier suitable for browsers. Use this in client side
 * only apps that do not run code on the server side in node.
 */
export function createAirbrakeClient(options) {
    return createAirbrakeClientBase({
        ...options,
        NotifierClass: NotifierBrowser
    });
}



// WEBPACK FOOTER //
// ./node_modules/@doxo/willow-airbrake/dist/esm/browser.js